import React, { Component } from "react";
import createMentionPlugin, {
  defaultSuggestionsFilter,
} from "@draft-js-plugins/mention";
import mentions from "./Mention";
import "./customToolbarEditor.css";
import "@draft-js-plugins/mention/lib/plugin.css";

export const mentionPlugin = createMentionPlugin();

export default class MentionTool extends Component {
  state = {
    suggestions: mentions,
    open: false,
  };

  onSearchChange = ({ value }) => {
    this.setState({
      suggestions: defaultSuggestionsFilter(value, mentions),
    });
  };
  onOpenChange = (_open) => {
    this.setState({
      open: _open,
    });
  };

  render() {
    const { MentionSuggestions } = mentionPlugin;
    return (
      <MentionSuggestions
        open={this.state.true}
        onSearchChange={this.onSearchChange}
        suggestions={this.state.suggestions}
        onOpenChange={this.onOpenChange}
      />
    );
  }
}
